export async function convertBase64ToFile(
  base64: string,
  filename: string,
): Promise<File> {
  const dataType = base64?.match(/^data:(.+);base64/)?.[1];
  const extension = dataType?.split('/').at(-1)?.toLowerCase();
  const response = await fetch(base64);
  const blob = await response.blob();

  const file = new File([blob], `${filename}.${extension}`, {
    type: dataType,
  });

  return file;
}
